<template>
    <div class="padding-h-15 padding-v-40">

        <div class="font-19 font-bold">
            <span :class="{'color-1477FD':status !== 1 && status !==2,
            'color-E34443':status === 2,
            'color-F3841E':status === 1}">H-
                <span class="color-14171B">Cash</span>
            </span>
        </div>
        <div class="margin-t-50 flex-h flex-v-center font-bold">
            <span class="font-35">₦{{formatCharacter(loanData.sRepaymentAmount)}}</span>
            <div class="padding-h-12 color-FFFFFF font-15">
                <van-button style="border-radius: 13px;height: 25px;" :color="status === 2 ?'linear-gradient(to right,#EE4747,#F78B8B)':
                status === 1 ? 'linear-gradient(to right,#F6A621, #FDD08D)' :
                'linear-gradient(to right,#1093FF, #69BBFF)'" block>{{status === 2 ? 'Overdue' :
                            status === 1 ? 'Expired':'Repayable'}}
                </van-button>
            </div>
        </div>

        <div class="margin-t-6 color-888F99 font-15 font-bold">
            Total amount
        </div>

        <div class="margin-t-30 flex-h font-15 font-bold">
            <div style="flex: 1;">
                <div class="color-888F99">
                    Interest(Received)
                </div>
                <div class="color-14171B font-23 margin-t-8">
                    ₦{{formatCharacter(loanData.interest)}}
                </div>
            </div>
            <div style="flex: 1;">
                <div class="color-888F99">
                    Service fee(Received)
                </div>
                <div class="color-14171B font-23 margin-t-8">
                    ₦{{formatCharacter(loanData.auditServiceExpense)}}
                </div>
            </div>
        </div>

        <div class="h-line-E6E8EB margin-t-35"></div>

        <div class="font-19 font-bold color-14171B flex-h flex-v-center margin-t-30 margin-b-22">
            <div class="w-6 h-18 radius-3" :class="{'linear-gradient-v-1093FF-to-69BBFF':status !== 1 && status !== 2,
            'linear-gradient-v-EE4747-to-F78B8B':status === 2,
            'linear-gradient-v-F6A621-to-FDD08D':status === 1}"></div>
            <span class="margin-l-11">Repayment Term</span>
        </div>

        <div class="flex-h margin-t-22">

            <div class="bg-F5F7FA radius-15 flex-v flex-h-center flex-v-center h-230" style="flex:1;">

                <van-circle v-model="currentRate" :rate="100" size="115" stroke-width="70" :color="status === 2 ?gradientColorOverDue:
                status === 1 ? gradientColorLittleOverDue : gradientColor">
                    <template #default>
                        <div class="font-45 font-bold margin-t-20">
                            {{Math.abs(loanData.orderInfo.overdueDays)}}
                        </div>
                        <div class="font-13 font-bold color-888F99">
                            days
                        </div>
                    </template>
                </van-circle>

                <div class="font-15 font-bold margin-t-22">
                    {{status === 2 ? 'Overdue':'Normal repayment'}}
                </div>

                <div class="margin-t-8 font-15 flex-h
                flex-h-center radius-13 w-55 padding-v-5 line-height-15 font-bold" :class="{'bg-FFD9D9':status === 2,
                'bg-FFF1D9':status === 1,
                'bg-D9EEFF':status !== 2 && status !== 1,
                'color-E34443':status === 2,
                'color-F3841E':status === 1,
                'color-1477FE':status !== 2 && status !== 1}">Tips
                </div>

            </div>

            <div style="flex:1;margin-left: 10px;" class="h-230">
                <div class="bg-F5F7FA radius-15 padding-l-20 flex-v flex-h-center h-75" style="flex:1;">
                    <div class="color-888F99 font-15 font-bold line-height-11-5">
                        {{status === 2 ? 'Loan amount':'Loan term'}}
                    </div>
                    <div class="color-14171B font-18 font-bold margin-t-10 line-height-14-5">
                        {{status === 2 ?
                        formatTime(loanData.applicationTime):loanData.loanAmount}}
                    </div>
                </div>

                <div class="bg-F5F7FA radius-15 h-145 flex-v flex-h-center padding-l-20 margin-t-10" style="flex:1;">
                    <div class="color-888F99 font-15 font-bold line-height-11-5">Loan term
                    </div>

                    <div class="color-14171B font-18 font-bold margin-t-10 line-height-17">
                        {{loanData.loanTimeLimit}}days
                    </div>

                    <div class="color-888F99 font-15 font-bold line-height-11-5 margin-t-26">Due date
                    </div>
                    <div class="color-14171B font-18 font-bold margin-t-10 line-height-17">
                        {{formatTime(loanData.orderInfo.originalDueDate)}}
                    </div>

                </div>
            </div>

        </div>

        <div class="margin-t-30 color-FFFFFF font-bold">
            <van-button style="height:55px;border-radius: 8px;font-size: 19px;" :color="status === 2 ?'linear-gradient(to right,#EE4747,#F78B8B)':
            status === 1? 'linear-gradient(to right,#F6A621, #FDD08D)' :
            'linear-gradient(to right,#1093FF, #69BBFF)'" @click="repayment_detail()" block>
                Repay now
            </van-button>
        </div>

        <div class="color-888F99 font-14 font-bold margin-t-15">
            Overdue repayment will result in additional penalty interest.
        </div>

    </div>
</template>

<script>
import format,{getOrderStatus} from "@/utils/tools";
export default {
    name: "repayment",
    data() {
        return {
            currentRate: 100,
            gradientColor: {
                '0%': '#1093FF',
                '100%': '#69BBFF',
            },
            gradientColorOverDue: {
                '0%': '#EE4747',
                '100%': '#F78B8B',
            },
            gradientColorLittleOverDue: {
                '0%': '#F6A621',
                '100%': '#FDD08D',
            },
            status: 0,
            loanData: {
                orderInfo: {
                    applicationId: '',
                    overdueDays: 0,
                    status: 0,
                    originalDueDate: ''
                },
                interest: 0,
                auditServiceExpense: 0,
                sRepaymentAmount: 0,
                applicationTime: '',
                loanAmount: 0,
                loanTimeLimit: 0,
            }
        }
    },
    mounted() {
        this.getLatest()
    },
    methods: {
        repayment_detail() {
            this.$router.push({
                path: 'repayment_detail',
                query: {
                    applicationId: this.loanData.orderInfo.applicationId
                }
            })
        },
        getLatest() {
            this.$showLoading()
            this.$request.latest()
                .then((res) => {
                    this.$hideLoading()
                    this.loanData = res
                    this.status = res.orderInfo.overdueDays < 0 ? 0 : res.orderInfo.overdueDays == 0 ? 1 : 2
                    let temStatus = getOrderStatus(res.status)
                    
                    if (![3, 4].includes(temStatus)) {
                        this.$router.push('home')
                    }

                })
                .catch(() => {
                    this.$hideLoading()
                })
        },
        formatTime(time) {
            return format.formatDateDDMMYYYY(time)
        },
        formatCharacter(character) {
            return format.formatCharacter(character)
        }
    }
}
</script>

<style scoped>

</style>